// export const COMPANY_PHONE_NUMBER = "+966536280324";
export const COMPANY_PHONE_NUMBER = "00966536280324";
export const COMPANY_LOCATION = "Saudi Arabia";
export const COMPANY_REGISTERED_ADDRESS =
  "Lorem ipsum dolor sit amit conectueteur";
export const COMPANY_POSTAL_ADDRESS = "Lorem ipsum dolor sit amit conectueteur";
export const COMPANY_EMAIL_ADDRESS = "info@arabgiftcard.com";
// export const COMPANY_VAT_NUMBER = 311716657500003;
export const COMPANY_VAT_NUMBER = "535 8569 58";
// export const COMPANY_REGISTRATION_NUMBER = 1010855714;
export const COMPANY_REGISTRATION_NUMBER = 22525625;

export const backgroundImagesForBanner = [
  "/assets/Style/new-banner.png",
  "/assets/Style/banner.png",
];

export const partnerLogo = [
  "/assets/Style/new-banner.png",
  "/assets/Style/banner.png",
  "/assets/Style/new-banner.png",
  "/assets/Style/banner.png",
  "/assets/Style/new-banner.png",
  "/assets/Style/banner.png",
  "/assets/Style/new-banner.png",
  "/assets/Style/banner.png",
  "/assets/Style/new-banner.png",
  "/assets/Style/banner.png",
];

export const responsiveImageSliderConfig = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const accordionData = [
  {
    id: "collapseOne",
    question: "What is the Arab Gift Card?",
    answer:
      "It is a digital platform that offers you a wide variety of famous local brands listed on our website for you to select from. We are mainly operating in Saudia Arabia and the MENA region!",
    order: "01",
  },
  {
    id: "collapseTwo",
    question: "What kind of gift cards can I find here?",
    answer:
      "At Arab Gift Card, you can purchase and gift digital codes for games, shopping, and cryptocurrency, all in one place. Call for more information!",
    order: "02",
  },
  {
    id: "collapseThree",
    question: "How to purchase an E-Gift Card?",
    answer:
      "You can do it using a credit/debit card or other payment methods. Steps:\nStep 1: Visit our website or download the app and select your preferred brand\nStep 2: Personalize by adding a message and card\nStep 3: Pay through online transfer or Credit/Debit card to Bank Transfer\nStep 4: Submit the form; you will get verification via email within 24 hours. The gift card will be delivered to your loved ones directly.",
    order: "03",
  },
  {
    id: "collapseFour",
    question: "What if my order did not go through?",
    answer:
      "If your order did not go through, it may be due to the payment information provided, such as changes to the cardholder's address, a new card number, insufficient funds in the account, the card being flagged as fraudulent or stolen, or the card being expired. Please contact your card's issuing bank to determine the issue. If it is not a Credit or Debit Card issue, please send us an email including your name, phone number, carrier if ordering Prepaid Phone Cards, email address, and billing address to Customer Service.",
    order: "04",
  },
  {
    id: "collapseFive",
    question: "Are there any restrictions on purchasing cards?",
    answer:
      "No. All retailer cards have a preset card value that is displayed on the ordering page.",
    order: "05",
  },
  {
    id: "collapseSix",
    question: "How can I create an Arab Gift Card account?",
    answer:
      "Visit our homepage and click Register to create an account. Fill in the registration form and follow the directions to confirm your email and mobile number.",
    order: "06",
  },
  {
    id: "collapseSeven",
    question: "How can I activate my Arab Gift Card account?",
    answer:
      "After registration, you will receive an email sent to your email address. Once you click the confirmation link, a confirmation code will be sent to your mobile. You will be guided from that point on.",
    order: "07",
  },
  {
    id: "collapseEight",
    question: "What is your refund policy?",
    answer:
      "We offer a 7-day no-questions-asked refund policy only when the gift card is not redeemed or damaged. The refund payment will be made the same way as the payment was made.",
    order: "08",
  },
  {
    id: "collapseNine",
    question: "How secure are my information / Credit Card details?",
    answer:
      "Your payment will be directly made through well-renowned and trustworthy financial gateways, so be assured that your data is in safe hands, and there will be no chance for any kind of data breach.",
    order: "09",
  },
  {
    id: "collapseTen",
    question: "Can I cancel or deactivate a Gift Card?",
    answer:
      "In order to cancel/deactivate your gift card, please get in touch with us via email or call, and you'll be connected with our Help Centre, and we'll do our best to assist. You'll need to provide the details of the Gift Card, including the Gift Card code.",
    order: "10",
  },
];
